module.exports=function(l,n,e){for(var r=0,t=l.length,o=3==arguments.length?e:l[r++];r<t;)o=n.call(null,o,l[r],++r,l);return o};